import React, { useEffect } from 'react';
import { navigate } from '@reach/router';
import { useIsAuthenticated, useMsal } from '@azure/msal-react';
import { InteractionStatus } from '@azure/msal-browser';

interface PrivateRouteProps {
    component: any;
    path?: string;
    [key: string]: any;
}

// Guards a route: if the user is not authenticated (no account/token found),
// redirect to the login page instead of rendering the protected component.
function PrivateRoute({ component: Component, path, ...rest }: PrivateRouteProps) {
    const isAuthenticated = useIsAuthenticated();
    const { inProgress } = useMsal();

    useEffect(() => {
        // Wait until MSAL has finished any startup/redirect processing before
        // deciding the user isn't authenticated, to avoid a false redirect
        // while a login/token refresh is still in progress.
        if (inProgress === InteractionStatus.None && !isAuthenticated) {
            navigate('/');
        }
    }, [inProgress, isAuthenticated]);

    if (!isAuthenticated) {
        return null;
    }

    return React.createElement(Component, rest);
}

export default PrivateRoute;
